export default {
  data()
  {
    return {
      buttons: {
        show: {
          faClass: 'eye',
          text: '',
          title: '_show',
          backgroundColor: '',
          color: ''
        },
        edit: {
          faClass: 'edit',
          text: '',
          title: '_modify',
          backgroundColor: '',
          color: ''
        },
        cancel: {
          faClass: 'trash-alt',
          text: '',
          title: '_cancel',
          backgroundColor: '',
          color: ''
        },
        disable: { // for travellers
          faClass: 'ban',
          text: '',
          title: '_enable',
          backgroundColor: '',
          color: ''
        },
        enable: { // for travellers
          faClass: 'check',
          text: '',
          title: ' _disable',
          backgroundColor: '',
          color: ''
        },
        duplicate: {
          faClass: 'clone',
          text: '',
          title: '_duplicate',
          backgroundColor: '',
          color: ''
        },
        download_pdf: {
          faClass: 'download',
          text: '',
          title: 'booking.download_pdf',
          backgroundColor: '',
          color: ''
        },
        download_ics: {
          faClass: 'calendar-alt',
          text: '',
          title: 'booking.download_ics',
          backgroundColor: '',
          color: ''
        },
        confirm: {
          faClass: 'check',
          faOnSelectOnly: true,
          text: 'OK',
          title: '_confirm',
          backgroundColor: '#e65011',
          color: 'white'
        },
        online_validate: {
          faClass: 'check',
          text: '',
          title: '_online_validate',
          backgroundColor: '',
          color: ''
        },
        allow: {
          faClass: 'check',
          faOnSelectOnly: true,
          text: 'OK',
          title: '_allow',
          backgroundColor: '#e65011',
          color: 'white'
        },
        deny: {
          faClass: 'times',
          text: '',
          title: '_deny',
          backgroundColor: '#1A2050',
          color: 'white'
        },
        contactBBA: {
          faClass: 'comments',
          title: 'booking.contactBBA'
        },
        send_voucher: {
          faClass: 'share-square',
          title: 'booking.select.send_voucher'
        },
        order_number: {
          faClass: 'pencil-alt',
          text: '',
          title: '_order_number_fill',
          backgroundColor: '#e65011',
          color: 'white'
        },
        download_order_pdf: {
          faClass: 'file',
          text: '',
          title: 'booking.download_order_pdf',
          backgroundColor: '',
          color: ''
        }
      }
    }
  }
}
